import { CampaignState } from './types'

export const campaignInitialState: CampaignState = {
	detailsData: {
		status: null,
		data: null,
	},
	listData: {
		status: null,
		data: [],
		pagination: null,
	},
}
